import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import ne from './locales/ne.json';

const localStorageDetector = {
  type: 'languageDetector' as const,
  async: false,
  detect: (): string => {
    return localStorage.getItem('user_language') || 'en';
  },
  init: () => {
    // No initialization needed for localStorage detector
  },
  cacheUserLanguage: (language: string) => {
    localStorage.setItem('user_language', language);
  },
};

// Initialize i18n synchronously - detector runs immediately before any i18n.t() calls
void i18n
  .use(localStorageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      it: { translation: it },
      fr: { translation: fr },
      de: { translation: de },
      ne: { translation: ne },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

window.addEventListener('storage', (event) => {
  if (event.key === 'user_language' && event.newValue) {
    void i18n.changeLanguage(event.newValue);
  }
});

window.addEventListener('languageChange', ((event: CustomEvent) => {
  if (event.detail?.language) {
    void i18n.changeLanguage(event.detail.language);
  }
}) as EventListener);

export default i18n;

export const changeLanguage = (language: string): void => {
  const supportedLanguages = ['en', 'fr', 'de', 'es', 'it', 'ne'];

  if (!supportedLanguages.includes(language)) {
    console.warn(
      `Unsupported language: ${language}. Supported: ${supportedLanguages.join(
        ', ',
      )}`,
    );
    return;
  }

  localStorage.setItem('user_language', language);
  window.dispatchEvent(
    new CustomEvent('languageChange', { detail: { language } }),
  );
};
